import Wall from "./wall";

export default function Stack(p5, yurtTraitStack, wallTrait) {
  const bottom = p5.height;
  let stack = [];

  function convertOrderToWalls() {
    for (let i = 0; i < yurtTraitStack.length; i++) {
      stack.push(new Wall(p5, bottom, yurtTraitStack[i]));
    }
  }

  convertOrderToWalls();

  this.render = () => {
    for (let i = 0; i < stack.length; i++) {
      stack[i].render();
    }
  };
}